import { useState } from 'react'
import { color, getImageColorStyle } from '@my/util'
import { ChevronDown, ChevronUp } from '@tamagui/lucide-icons-2'
import { ActionButton, SimpleText, YStack, Image, XStack, TZACardStyle } from '@my/ui'
import { shadowGenerator } from '../../../../utils/commonStyles'
import images from '../../../../assets/images'

export const QuickWinCard = (props: QuickWinCardProps) => {
  const { title, timeLeft, themeColor, details, status } = props
  const [isExpanded, setIsExpanded] = useState(false)
  const dynamicHeight = isExpanded ? {/*  height: '100%' */} : {}
  const maxWidth = 350
  return (
    <XStack minWidth={250} maxWidth={maxWidth} style={{
        width: '100%',
        borderStyle: 'solid', borderWidth: 1, ...TZACardStyle, backgroundImage: 'none', ...dynamicHeight, flexShrink: 1 
      }}>
      <ActionButton
        unstyled
        borderRadius={10}
        backgroundColor={color.white}
        onPress={() => setIsExpanded((prev) => !prev)}
        minWidth={250}
        maxWidth={maxWidth}
        height={'100%'}
        minHeight={105}
        style={{overflow: 'hidden', width: '100%'}}
        {...shadowGenerator(0.2)}
      >
        {/* Card Header */}
        <CardHeader
          title={title}
          timeLeft={timeLeft}
          isExpanded={isExpanded}
          themeColor={themeColor}
        />
        {/* Expanded Details */}
        {isExpanded && (
          <YStack paddingHorizontal="$4" paddingBottom="$4" gap={10} maxWidth={maxWidth}>
            {/* Details */}
            <SimpleText fontSize={15} color={color.lightGrey}>
              {details}
            </SimpleText>
            <DetailSummary themeColor={themeColor} timeLeft={timeLeft} status={status} />
            {/* <ActionButton
              p="$3"
              unstyled
              alignItems={'center'}
              borderWidth={1}
              borderColor={color.tzaGreen}
              borderRadius={4}
              marginVertical="$3"
              pressStyle={{
                opacity: 0.5,
              }}
              onPress={() => {}}
            >
              <SimpleText fontSize={14} fontWeight={'600'} color={color.tzaGreen}>
                Do it Now
              </SimpleText>
            </ActionButton> */}
          </YStack>
        )}
      </ActionButton>
    </XStack>
  )
}

const CardHeader = ({ title, timeLeft, isExpanded, themeColor }: QuickWinCardHeaderProps) => {
  const { grey } = color
  return (
    <XStack flexDirection="row" justifyContent="space-between" alignItems="center" padding="$4">
      <YStack>
        <SimpleText width={title.length < 30 ? 200 : 250} minHeight={48} fontSize={18} fontWeight="bold" color={'rgb(73, 80, 87)'}>
          {title}
        </SimpleText>
        {!isExpanded ? (
          <XStack alignItems={'center'} gap={5}>
            <Image
              src={images.clock}
              style={{ height: 14, width: 14, ...getImageColorStyle(color.black) }}
              resizeMode="contain"
              tintColor={color.black}
            />
            <SimpleText fontSize={14} color={grey}>
              {timeLeft} min
            </SimpleText>
          </XStack>
        ) : null}
      </YStack>
      <ActionButton
        unstyled
        disabled
        color={grey}
        borderRadius={3}
        backgroundColor={themeColor}
        icon={isExpanded ? ChevronUp : ChevronDown}
        style={{ height: 18, width: 18, alignItems: 'center', justifyContent: 'center' }}
      />
    </XStack>
  )
}

const DetailSummary = ({ timeLeft, status }: QuickWinDetailSummaryProps) => {
  const statusColor = status == 'Complete' ? color.tzaGreen : color.lightRed;
  return <XStack flexDirection="row" alignItems={'center'} gap={20} marginTop={'auto'}>
    <XStack alignItems={'center'} gap={5}>
      <Image
        src={images.clock}
        style={{ height: 14, width: 14, ...getImageColorStyle(color.black) }}
        resizeMode="contain"
        tintColor={color.black}
      />
      <SimpleText fontSize={14} color={color.grey}>
        {timeLeft} min
      </SimpleText>
    </XStack>
    <XStack alignItems={'center'} gap={5}>
      <Image
        src={images.clock}
        style={{ height: 14, width: 14, ...getImageColorStyle(statusColor) }}
        resizeMode="contain"
        tintColor={statusColor}
      />
      <SimpleText fontSize={14} color={statusColor}>
        {status}
      </SimpleText>
    </XStack>
  </XStack>
}
